import "./search.css";
import { BiSearch } from "react-icons/bi";
import { SuggestionBox } from "../suggestion box/SuggestionBox";
import { useProductsData } from "../../context/product-context";

export const SearchBar = () => {
  const { showBox, setShowBox } = useProductsData();

  const focusHandler = () => {
    setShowBox(true);
  };

  return (
    <div className="hero-con">
      <div className="search-con">
        <input
          type="text"
          className="search-bar"
          placeholder="Search"
          onFocus={focusHandler}
        />
        <BiSearch size={25} className="grey-text" />
      </div>
      {showBox ? <SuggestionBox /> : null}
    </div>
  );
};
